<script lang="ts">
  import { icon } from '#app/lib/icons'
  import Modal from '#components/modal.svelte'
  import type { SerializedItemWithUserData } from '#inventory/lib/items'
  import RequestItem from '#transactions/components/request_item.svelte'
  import { hasOngoingTransactionsByItemIdSync } from '#transactions/lib/helpers'
  import { i18n, I18n } from '#user/lib/i18n'
  import { mainUser } from '#user/lib/main_user'

  const {
    item,
  }: {
    item: SerializedItemWithUserData
  } = $props()

  const itemId = $derived(item._id)
  const restricted = $derived(item.restricted)
  const transaction = $derived(item.transaction)
  const busy = $derived(item.busy)

  const hasActiveTransaction = $derived(mainUser ? hasOngoingTransactionsByItemIdSync(itemId) : false)
  let showRequestItemModal: boolean = $state()
</script>

{#if restricted}
  {#if busy}
    <div class="busy-box">
      {@html icon('sign-out')}{i18n('unavailable')}
    </div>
  {:else}
    {#if hasActiveTransaction}
      <span class="main-user-requested">
        {i18n('main_user_requested')}
      </span>
    {:else}
      {#if transaction !== 'inventorying'}
        <button
          aria-haspopup="dialog"
          onclick={() => showRequestItemModal = true}
        >
          {@html icon('comments')}
          {I18n('send request')}
        </button>
      {/if}
    {/if}
  {/if}
{/if}

{#if showRequestItemModal}
  <Modal onCloseModal={() => showRequestItemModal = false}>
    <RequestItem {item} />
  </Modal>
{/if}

<style lang="scss">
  @import "general/scss/utils";
  button{
    // just 'height' wasnt working on chrome
    min-height: $user-box-heigth;
    max-height: $user-box-heigth;
    font-weight: normal;
    @include bg-hover($light-grey, 10%);
    @include text-hover($dark-grey, $darker-grey);
    transition: color 0.3s ease, background-color 0.3s ease;
    width: 100%;
    @include display-flex(row, center, center);
  }
  .main-user-requested, .busy-box{
    min-height: $user-box-heigth;
    width: 100%;
    @include display-flex(row, center, center);
  }
  .busy-box{
    background-color: #444;
    color: white;
  }
</style>
